/**
 * The label under an account's name: "▼ Declining", "▲ Growing", or plain
 * "Steady". Hovering shows what the signal means. The text comes from
 * pages.pcInsights.signals.<key> in the locale files.
 */

import { useTranslation } from "react-i18next";
import type { Signal, SignalGroup } from "@onsemble/shared/types/sales-insights";

// Arrow and text color for each group; steady gets neither
const LOOK: Record<SignalGroup, { glyph: string; className: string }> = {
  risk: { glyph: "▼ ", className: "text-si-down" }, // bad news
  opportunity: { glyph: "▲ ", className: "text-si-up" }, // good news
  steady: { glyph: "", className: "" }, // nothing to flag
};

export function SignalTag({ signal }: { signal: Signal }) {
  const { t } = useTranslation();
  // Fall back to the raw key, so a signal with no text yet is visible, not blank
  const name = t(`pages.pcInsights.signals.${signal.key}.name`, { defaultValue: signal.key });
  // Hover text; empty when there's no definition for this key
  const definition = t(`pages.pcInsights.signals.${signal.key}.definition`, { defaultValue: "" });
  const look = LOOK[signal.group];
  return (
    <span className={look.className} title={definition || undefined}>
      {look.glyph}
      {name}
    </span>
  );
}
